import axios from 'axios'
const Axios = axios.create({
  // ${__DEV_SERVER_HOST__}
  baseURL: process.env.NODE_ENV === 'production' ? 'https://chat.laway.cn' : `https://chat.laway.cn`,
  timeout: 60000
})
/**
 * 请求拦截器
 */
Axios.interceptors.request.use(
  config => {
    config.headers = config.headers || {}
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

/**
 * 响应拦截器
 */
Axios.interceptors.response.use(
  // 响应成功
  res => {
    const { status, data } = res
    if (status === 200) {
      if (data.code !== 1) {
        return Promise.reject(res.data)
      } else {
        return Promise.resolve(res.data.result || true)
      }
    } else {
      return Promise.reject(res.data)
    }
  },
  // 响应失败
  async (err) => {
    const error = err.response
    if (!error) {
      return Promise.reject(err)
    } else {
      const { status } = error
      switch (status) {
        case 401:
          return Promise.reject(error)
        case 403:
          return Promise.reject(error)
        case 404:
          return Promise.reject(error)
        default:
          return Promise.reject(error)
      }
    }
  }
)

// export default Axios

/**
 * @param {String} url 请求地址
 * @param {Object} params 请求参数对象
 */
const post = (url, params = {}) => {
  return Axios.post(url, params)
}

/**
 * @param {String} url 请求地址
 * @param {Object} params 请求参数对象
 */
const get = (url, params) => {
  return Axios.get(url, { params })
}

export {
  post,
  get,
}

export function confirmEvaluate (data) {
  return post('/api/rtcRecord/update', {
    appUUID: '14ee8a3c-e391-4ace-bcae-e32f8f6364ca',
    messageUUID: data.messageUUID,
    satisFaction: data.rate,
    satisLevel: data.rate,
    satisAttribute: JSON.stringify({
      content: data.content,
    }),
    statisTime: data.time
  })
}

export function confirmLeaveMessage (data) {
  return post('/api/rtcRecord/update', {
    appUUID: '14ee8a3c-e391-4ace-bcae-e32f8f6364ca',
    messageUUID: data.messageUUID,
    consumerPhone: data.phone,
    note: data.content
  })
}

export function getDeviceRule (code) {
  return get('/api/machine/rule/list', {
    appUUID: '14ee8a3c-e391-4ace-bcae-e32f8f6364ca',
    code
  })
}